import { render } from "./IconIllustrationAutorisation.vue?vue&type=template&id=65241210"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__